import { render, staticRenderFns } from "./VOverlayLoader.vue?vue&type=template&id=3909fb53"
import script from "./VOverlayLoader.vue?vue&type=script&lang=js"
export * from "./VOverlayLoader.vue?vue&type=script&lang=js"
import style0 from "./VOverlayLoader.vue?vue&type=style&index=0&id=3909fb53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports